// extracted by mini-css-extract-plugin
module.exports = {"main":"content_main__2YHpf","container":"content_container__1ms4z","topicContainer":"content_topicContainer__2wuuj"};